// use-case применить контекст команды
// найти команду
// обновить выбранную команду
// запросить и обновить права

import { getPermissionsUser } from "@/components/service/api";
import { usePermissionsStore, useProductsStore, useTeamStore } from "@/store/modules";

export async function applyTeamContext({ team, teamSlug, mergePermissions }) {
  const teamStore = useTeamStore();
  const permissionsStore = usePermissionsStore();

  const targetTeam =
    team ||
    teamStore.allTeams.find((item) => item?.team?.slug === teamSlug) ||
    (teamStore.myTeam?.team?.slug === teamSlug ? teamStore.myTeam : null);

  if (!targetTeam?.team?.slug) {
    throw new Error("Target team not found");
  }

  const currentSlug = teamStore.selectedTeam?.team?.slug;

  if (currentSlug !== targetTeam.team.slug) {
    // обновляем если не та де команда
    teamStore.setSelectedTeam(targetTeam);
    localStorage.setItem("selectedTeamSlug", targetTeam.team.slug);
    // при смене команды сбрасываем режим копирования оформления/массового выбора продуктов,
    // т.к. выбранные продукты и продукт-донор относятся к предыдущей команде
    useProductsStore().cancelBulkSelection();
  }

  const result = await getPermissionsUser(targetTeam.team.slug); // всегда запрашиваем права

  if (result) {
    permissionsStore.SET_VALUE({
      key: "allScopes",
      value: result.allScopes,
    });

    if (typeof mergePermissions === "function") {
      mergePermissions(result.scopes, result.allScopes);
    }
  }

  return targetTeam;
}
